import { API_ROUTES } from '../constants';
import { handleResponse, axiosInstance } from './helper';

const getBreathTrainingDashboardDataApi = () =>
  handleResponse(axiosInstance.get(API_ROUTES.getBreathTrainingDashboardData));

const updateBreathTrainingCommentApi = (data: { id: string; comment: string }) =>
  handleResponse(axiosInstance.put(API_ROUTES.updateBreathTrainingComment, data));

const markBreathTrainingRowAsImportantApi = (data: { id: string; important: boolean }) =>
  handleResponse(axiosInstance.put(API_ROUTES.markBreathTrainingRowAsImportant, data));

export {
  getBreathTrainingDashboardDataApi,
  updateBreathTrainingCommentApi,
  markBreathTrainingRowAsImportantApi
};
